document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

function dmUnlockIntroOnDeepLinks() {
  var path = window.location.pathname || '/';
  var isHome = path === '/' || /^\/(?:zh-hans|zh-hant)\/?$/.test(path);
  if (isHome) return;

  document.documentElement.style.background = '';
  if (document.body) {
    document.body.classList.remove('dm-intro-active');
    document.body.style.overflow = '';
    document.body.style.position = '';
  }

  var overlay = document.getElementById('dm-intro-overlay');
  if (overlay) {
    overlay.style.display = 'none';
    overlay.style.visibility = 'hidden';
    overlay.style.pointerEvents = 'none';
    overlay.remove();
  }
}

dmUnlockIntroOnDeepLinks();
document.addEventListener('DOMContentLoaded', dmUnlockIntroOnDeepLinks);
window.addEventListener('load', dmUnlockIntroOnDeepLinks);
setTimeout(dmUnlockIntroOnDeepLinks, 0);
setTimeout(dmUnlockIntroOnDeepLinks, 500);

/* ── Variant selects (product page) ──────────────────────────────────── */
class DragonMaidenVariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    const form = this.closest('form');
    const selectedOptions = Array.from(this.querySelectorAll('input:checked')).map((i) => i.value);
    const variantsScript = this.querySelector('[type="application/json"]');
    if (!form || !variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);
    const variant = variants.find((v) => v.options.every((o, i) => o === selectedOptions[i]));
    const variantInput = form.querySelector('[name="id"]');
    if (variant && variantInput) {
      variantInput.value = variant.id;
      form.querySelector('[type="submit"]')?.toggleAttribute('disabled', !variant.available);
    }
  }
}
customElements.define('dragon-maiden-variant-selects', DragonMaidenVariantSelects);


/* ── Cart toast ──────────────────────────────────────────────────────── */
function showCartToast(message) {
  let toast = document.querySelector('.dm-cart-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'dm-cart-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
}

/* ── Shared helpers ──────────────────────────────────────────────────── */
function openCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.dispatchEvent(new CustomEvent('cart:open'));
  drawer.setAttribute('open', '');
}

function refreshCartCount() {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count > 0 ? ' · ' + cart.item_count : '';
      });
    });
}

/* ── AJAX add-to-cart ────────────────────────────────────────────────── */
async function addToCart(variantId, btn, properties) {
  if (!variantId) return;

  btn.classList.add('is-adding');
  btn.disabled = true;

  const payload = { id: variantId, quantity: 1 };
  if (properties && Object.keys(properties).length) payload.properties = properties;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error('Cart error');

    const data = await res.json();

    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    btn.disabled = false;
    setTimeout(() => btn.classList.remove('is-added'), 2000);

    showCartToast('Added · ' + data.title);
    refreshCartCount();
    openCartDrawer();

  } catch {
    btn.classList.remove('is-adding');
    btn.disabled = false;
    showCartToast('Could not add to cart');
  }
}

/* ── Product form AJAX submit ────────────────────────────────────────── */
function initSizeGuideModal() {
  document.querySelectorAll('.dm-size-guide-trigger').forEach((trigger) => {
    if (trigger._dmSizeGuideInit) return;
    trigger._dmSizeGuideInit = true;

    const modalId = trigger.getAttribute('aria-controls');
    const modal = modalId ? document.getElementById(modalId) : document.querySelector('.dm-size-guide-modal');
    if (!modal) return;

    const panel = modal.querySelector('.dm-size-guide-modal__panel');

    const updateUnits = (unit) => {
      modal.querySelectorAll('[data-cm][data-in]').forEach((value) => {
        value.textContent = unit === 'in' ? value.dataset.in : value.dataset.cm;
      });
    };

    const openModal = () => {
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('dm-modal-open');
      updateUnits(modal.querySelector('[name="dm-size-guide-unit"]:checked')?.value || 'cm');
      panel?.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('dm-modal-open');
      trigger.focus();
    };

    trigger.addEventListener('click', openModal);

    modal.querySelectorAll('[data-size-guide-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    modal.querySelectorAll('[data-size-guide-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.sizeGuideTab;

        modal.querySelectorAll('[data-size-guide-tab]').forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        })

        modal.querySelectorAll('.dm-size-guide-panel').forEach((guidePanel) => {
          const isActive = guidePanel.id === `dm-size-panel-${target}`;
          guidePanel.classList.toggle('is-active', isActive);
          guidePanel.hidden = !isActive;
        });
      });
    });

    modal.querySelectorAll('[name="dm-size-guide-unit"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) updateUnits(input.value);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
}


/* ── Collection grid interactions ───────────────────────────────────── */
function initCollectionGrid() {
  /* size buttons → select variant (highlight only) */
  document.querySelectorAll('.dm-size-btn:not([disabled])').forEach((btn) => {
    if (btn._dmInit) return;
    btn._dmInit = true;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.dm-shop-card');
      card.querySelectorAll('.dm-size-btn').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  /* ATC button → add selected size variant to cart */
  document.querySelectorAll('.dm-card-atc').forEach((btn) => {
    if (btn._dmInit) return;
    btn._dmInit = true;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.dm-shop-card');
      const activeSize = card ? card.querySelector('.dm-size-btn.is-active') : null;
      const variantId = activeSize ? activeSize.dataset.variantId : btn.dataset.variantId;
      if (!variantId) { showCartToast('请先选择尺码'); return; }
      addToCart(variantId, btn);
    });
  });

  /* color swatches → swap card image */
  document.querySelectorAll('.dm-swatch').forEach((swatch) => {
    if (swatch._dmInit) return;
    swatch._dmInit = true;
    swatch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = swatch.closest('.dm-shop-card');
      if (!card) return;
      const img = swatch.dataset.img;
      if (!img) return;

      card.querySelectorAll('.dm-swatch').forEach((s) => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      const primary = card.querySelector('.dm-img-primary');
      if (primary) {
        primary.src = img;
        primary.srcset = img;
      }
    });
  });
}

/* run on DOM ready and after Shopify section re-renders */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { initCollectionGrid(); initProductForm(); initSizeGuideModal(); });
} else {
  initCollectionGrid();
  initProductForm();
  initSizeGuideModal();
}

document.addEventListener('shopify:section:load', () => { initCollectionGrid(); initProductForm(); initSizeGuideModal(); });
